import { ProductCatalogSortColumns } from "@vviinn/user-managment-client-ts";

import {
  RequestHandlerParams,
  fetchProducts,
  textSearchProducts,
  fetchAutosuggestions,
  fetchCategories,
} from "../store";
import { inputProductTypesMapping } from "./details/components/form/components/renderAttribute/constants";

export const handleProduct = (
  params: RequestHandlerParams,
  siteId?: number,
  companyId?: string,
) => {
  const { getApi, notify, dispatch } = params;

  return {
    async copyNotification(str: string) {
      try {
        await navigator.clipboard.writeText(str);
        notify("Success", "Product ID has been copied successfully");
      } catch (error) {
        let errorMessage = "Unknown Error";
        if (error instanceof Error) {
          errorMessage = error.message;
        }
        notify("Error", errorMessage);
      }
    },

    async getProducts(
      filter = "",
      currentCursor = "",
      itemsPerPage = 1,
      sort: ProductCatalogSortColumns[] = [],
    ) {
      if (!siteId || !companyId) return;

      const api = await getApi();
      dispatch(
        fetchProducts({
          api,
          value: {
            companyId,
            siteId,
            filter,
            cursor: currentCursor,
            limit: itemsPerPage,
            sort,
          },
        }),
      );
    },

    async getProductAutosuggestions(fields: string[]) {
      if (!siteId || !companyId) return;
      const api = await getApi();
      const productAttributeFields = [
        ...fields,
        ...inputProductTypesMapping.map(({ name }) => name),
      ];
      for (const tableColumn of productAttributeFields) {
        dispatch(
          fetchAutosuggestions({
            api,
            value: {
              companyId,
              siteId,
              siteTable: "product",
              tableColumn,
            },
          }),
        );
      }
      dispatch(fetchCategories({ api, value: { companyId, siteId } }));
    },

    async fetchTextSearchProducts(filter: string) {
      if (!siteId || !companyId) return;
      const api = await getApi();

      dispatch(
        textSearchProducts({
          api,
          value: {
            companyId,
            siteId,
            textSearchQuery: filter,
          },
        }),
      );
    },
  };
};
